import { createHeadShakeFrames } from "../../core/personality-keyframes.js";

export const meta = Object.freeze({
  id: "head-shake",
  label: "Nein sagen",
  duration: 1400,
  description: "Ein klares, elastisch abklingendes Kopfschütteln für Nein-Reaktionen.",
  tags: ["body", "expression", "reaction", "one-shot", "loopable"],
});

export async function run({ elements, animate }) {
  const frames = createHeadShakeFrames();
  const options = { duration: meta.duration, easing: "linear" };
  const animations = [
    animate(elements.actor, frames.body, options),
    animate(elements.shadow, frames.shadow, options),
    animate(elements.eyes, frames.eyes, options),
    animate(elements.mouthFlat, frames.mouth, options),
  ];
  await Promise.allSettled(animations.map(({ finished }) => finished));
}
